/* Naggat Silver — theme JavaScript
   Cart AJAX, cart drawer, quick view, variant pickers, UI toggles. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function getCheckoutUrl() {
    if (routes.checkout) { return routes.checkout; }
    var root = (routes.root || '/').replace(/\/$/, '');
    return root + '/checkout';
  }

  /* ---------- Money ---------- */

  /* Fixed shop format: comma thousands separator, no decimals,
     currency code after the amount — matches snippets/money.liquid. */
  function formatMoney(cents) {
    var value = parseInt(cents, 10);
    if (isNaN(value)) { value = 0; }
    var whole = Math.floor(Math.abs(value) / 100);
    var sign = value < 0 ? '-' : '';
    var formatted = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return sign + formatted + ' ' + (theme.currency || 'EGP');
  }

  /* ---------- Cart API ---------- */

  var Cart = {
    add: function (formData) {
      var addUrl = (routes.cartAdd || '/cart/add') + '.js';
      return fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) { throw data; }
          return data;
        });
      });
    },
    change: function (line, quantity) {
      var changeUrl = (routes.cartChange || '/cart/change') + '.js';
      return fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) { throw data; }
          return data;
        });
      });
    }
  };

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  function refreshCartDrawer() {
    var rootUrl = routes.root || '/';
    var sep = rootUrl.indexOf('?') === -1 ? '?' : '&';
    return fetch(rootUrl + sep + 'sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        var current = qs('#shopify-section-cart-drawer');
        if (!html || !current) { return; }
        var tpl = document.createElement('template');
        tpl.innerHTML = html.trim();
        var fresh = tpl.content.querySelector('#shopify-section-cart-drawer') || tpl.content.firstElementChild;
        if (fresh) {
          current.replaceWith(fresh);
          /* is-open must target the inner <aside id="CartDrawer">, not the
             outer shopify-section wrapper div that Section Rendering returns. */
          if (currentDrawerOpen) {
            var innerDrawer = fresh.querySelector('#CartDrawer') || (fresh.id === 'CartDrawer' ? fresh : null);
            if (innerDrawer) {
              innerDrawer.classList.add('is-open');
              innerDrawer.setAttribute('aria-hidden', 'false');
            }
          }
        }
      });
  }

  function afterCartMutation(cart) {
    updateCartCount(cart.item_count);
    var onCartPage = qs('[data-cart-page]');
    if (onCartPage) {
      window.location.reload();
      return Promise.resolve();
    }
    return refreshCartDrawer();
  }

  /* ---------- Drawer / modal state ---------- */

  var currentDrawerOpen = false;

  function lockBody() {
    document.body.classList.add('has-drawer');
  }

  function unlockBodyIfIdle() {
    var anyOpen = qs('.drawer.is-open, .modal.is-open');
    if (!anyOpen) {
      document.body.classList.remove('has-drawer');
      document.body.classList.remove('has-modal');
    }
  }

  function openCartDrawer() {
    if (!theme.cartDrawer) { return; }
    var drawer = qs('#CartDrawer');
    if (!drawer) { return; }
    currentDrawerOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockBody();
    var closeBtn = qs('[data-cart-close]', drawer);
    if (closeBtn && closeBtn.tagName === 'BUTTON') {
      try { closeBtn.focus({ preventScroll: true }); } catch (_) { closeBtn.focus(); }
    }
  }

  function closeCartDrawer() {
    var drawer = qs('#CartDrawer');
    if (!drawer) { return; }
    currentDrawerOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockBodyIfIdle();
  }

  function openMenuDrawer() {
    var drawer = qs('#MenuDrawer');
    var toggle = qs('[data-menu-open]');
    if (!drawer) { return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggle) { toggle.setAttribute('aria-expanded', 'true'); }
    lockBody();
    var closeBtn = qs('[data-menu-close]', drawer);
    if (closeBtn && closeBtn.tagName === 'BUTTON') {
      try { closeBtn.focus({ preventScroll: true }); } catch (_) { closeBtn.focus(); }
    }
  }

  function closeMenuDrawer() {
    var drawer = qs('#MenuDrawer');
    var toggle = qs('[data-menu-open]');
    if (!drawer) { return; }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); }
    unlockBodyIfIdle();
  }

  /* ---------- Quick view ---------- */

  var quickViewRoot = qs('#QuickViewRoot');
  var quickViewContent = qs('#QuickViewContent');
  var lastFocused = null;

  function openQuickView() {
    if (!quickViewRoot) { return; }
    quickViewRoot.classList.add('is-open');
    quickViewRoot.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-modal');
    lockBody();
  }

  function closeQuickView() {
    if (!quickViewRoot) { return; }
    quickViewRoot.classList.remove('is-open');
    quickViewRoot.setAttribute('aria-hidden', 'true');
    unlockBodyIfIdle();
    if (lastFocused) {
      lastFocused.focus();
      lastFocused = null;
    }
  }

  function showQuickViewSpinner() {
    if (!quickViewContent) { return; }
    quickViewContent.innerHTML =
      '<div class="cart-empty"><p class="headline-md">Loading…</p></div>';
  }

  function fetchQuickView(url) {
    if (!url || !quickViewContent) { return; }
    lastFocused = document.activeElement;
    showQuickViewSpinner();
    openQuickView();
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('#shopify-section-quick-view') || doc.body.firstElementChild;
        quickViewContent.innerHTML = section ? section.innerHTML : html;
        initVariantPickers(quickViewContent);
        var panel = qs('[data-quick-view-panel]');
        if (panel) { panel.scrollTop = 0; panel.focus(); }
      })
      .catch(function () {
        closeQuickView();
      });
  }

  /* ---------- Variant pickers ---------- */

  function initVariantPickers(scope) {
    qsa('[data-variant-picker]', scope || document).forEach(function (picker) {
      if (picker.dataset.variantInit) { return; }
      picker.dataset.variantInit = 'true';

      var jsonEl = qs('script[data-variant-json]', picker);
      if (!jsonEl) { return; }
      var variants;
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }
      if (!variants || !variants.length) { return; }

      var form = picker.closest('form');
      if (!form) { return; }
      var productRoot = picker.closest('[data-product-root]') || document;
      var hiddenId = qs('[data-variant-id], input[name="id"]', form);
      var atc = qs('[data-atc]', form);
      var atcLabel = atc ? atc.textContent.trim() : '';
      var buyNowBtn = qs('[data-buy-now], .product-form__buynow', form);
      var radios = qsa('input[type="radio"][data-option-index]', picker);
      var optionCount = variants[0].options ? variants[0].options.length : 0;

      function selectedOptions() {
        var opts = new Array(optionCount);
        radios.forEach(function (radio) {
          if (radio.checked) {
            var idx = parseInt(radio.dataset.optionIndex, 10);
            if (!isNaN(idx)) { opts[idx] = radio.value; }
          }
        });
        return opts;
      }

      function findVariant(opts) {
        if (radios.length === 0) {
          return variants[0];
        }
        return variants.find(function (v) {
          return v.options.length === opts.length &&
            opts.every(function (val, i) { return val !== undefined && v.options[i] === val; });
        });
      }

      function updateAvailability(currentOpts) {
        radios.forEach(function (radio) {
          var idx = parseInt(radio.dataset.optionIndex, 10);
          var testOpts = currentOpts.slice();
          testOpts[idx] = radio.value;
          var match = variants.find(function (v) {
            return v.options.every(function (val, i) {
              return testOpts[i] === undefined || testOpts[i] === val;
            });
          });
          var label = qs('label[for="' + radio.id + '"]', picker);
          if (label) {
            label.classList.toggle('is-unavailable', !match || !match.available);
          }
        });
      }

      function updatePrice(variant) {
        if (!variant) { return; }
        var current = qs('[data-price-current]', productRoot);
        var compare = qs('[data-price-compare]', productRoot);
        var badge = qs('[data-price-badge]', productRoot);
        if (current) { current.textContent = formatMoney(variant.price); }
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compare) {
          compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
          compare.style.display = onSale ? '' : 'none';
        }
        if (badge) { badge.style.display = onSale ? '' : 'none'; }
        var stickyPrice = qs('[data-sticky-price]');
        if (stickyPrice && productRoot !== document) {
          stickyPrice.textContent = formatMoney(variant.price);
        }
      }

      function updateButton(variant) {
        if (atc) {
          if (!variant) {
            atc.disabled = true;
            atc.textContent = strings.unavailable || 'Unavailable';
          } else if (!variant.available) {
            atc.disabled = true;
            atc.textContent = strings.soldOut || 'Sold out';
          } else {
            atc.disabled = false;
            atc.textContent = strings.addToCart || atcLabel || 'Add to cart';
          }
        }

        if (buyNowBtn) {
          buyNowBtn.disabled = !variant || !variant.available;
        }

        var mainForm = qs('[data-product-form-main]');
        if (mainForm && productRoot !== document && productRoot.contains(mainForm)) {
          var stickyAdd = qs('[data-sticky-add]');
          if (stickyAdd) {
            if (!variant) {
              stickyAdd.disabled = true;
              stickyAdd.textContent = strings.unavailable || 'Unavailable';
            } else if (!variant.available) {
              stickyAdd.disabled = true;
              stickyAdd.textContent = strings.soldOut || 'Sold out';
            } else {
              stickyAdd.disabled = false;
              stickyAdd.textContent = strings.addToCart || 'Add to cart';
            }
          }
        }
      }

      function updateImage(variant) {
        if (!variant || !variant.featured_media) { return; }
        var img = qs('[data-main-image]', productRoot);
        if (!img) { return; }
        var src = variant.featured_media.src || (variant.featured_media.preview_image && variant.featured_media.preview_image.src);
        if (!src) { return; }
        if (src.indexOf('//') === 0) { src = 'https:' + src; }
        img.srcset = '';
        img.sizes = '';
        img.src = src;
        qsa('[data-thumb]', productRoot).forEach(function (thumb) {
          thumb.classList.toggle('is-active', thumb.dataset.mediaId === String(variant.featured_media.id));
        });
      }

      function updateInventoryMax(variant) {
        var qtyInput = qs('[data-qty-input]', form);
        if (!qtyInput) { return; }
        var max = variant && typeof variant.inventory_max === 'number' && variant.inventory_max > 0
          ? variant.inventory_max
          : null;
        if (max) {
          qtyInput.setAttribute('max', max);
          if ((parseInt(qtyInput.value, 10) || 1) > max) { qtyInput.value = max; }
        } else {
          qtyInput.removeAttribute('max');
        }
      }

      function update() {
        var opts = selectedOptions();
        var variant = findVariant(opts);
        if (variant) {
          if (hiddenId) {
            var changed = String(hiddenId.value) !== String(variant.id);
            hiddenId.value = variant.id;
            if (changed) {
              hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          updatePrice(variant);
          updateButton(variant);
          updateInventoryMax(variant);
          updateImage(variant);
          qsa('[data-selected-value]', picker).forEach(function (el, i) {
            el.textContent = variant.options[i];
          });
        } else {
          updateButton(null);
        }
        if (radios.length > 0) {
          updateAvailability(opts);
        }
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', update);
      });

      if (radios.length > 0) {
        update();
      } else {
        updateInventoryMax(variants[0]);
      }
    });
  }

  /* ---------- Quantity steppers ---------- */

  function stepQty(btn) {
    var wrap = btn.closest('.qty');
    if (!wrap) { return null; }
    var input = qs('[data-qty-input]', wrap);
    if (!input) { return null; }
    var value = parseInt(input.value, 10) || 0;
    value += btn.hasAttribute('data-qty-plus') ? 1 : -1;
    var min = parseInt(input.getAttribute('min'), 10);
    if (!isNaN(min) && value < min) { value = min; }
    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && value > max) { value = max; }
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return value;
  }

  /* ---------- Sticky mobile ATC ---------- */

  /* Measure the real rendered header height and publish it as
     --header-height-actual. base.css uses it for the body top
     offset and the sticky product-info column, so the fixed
     header neither covers content nor leaves a dead gap, even
     when the header grows (e.g. navigation wrapping). */
  function initHeaderHeight() {
    var header = qs('.site-header');
    if (!header) { return; }

    var ticking = false;
    var setHeight = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var h = header.offsetHeight;
        document.documentElement.style.setProperty(
          '--header-height-actual',
          h + 'px'
        );
        ticking = false;
      });
    };

    setHeight();
    window.addEventListener('resize', setHeight, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(setHeight).observe(header);
    }
  }

  function initStickyAtc() {
    var sticky = qs('[data-sticky-atc]');
    var mainForm = qs('[data-product-form-main]');
    if (!sticky || !mainForm) { return; }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '-80px 0px 0px 0px' });
      observer.observe(mainForm);
    } else {
      sticky.classList.add('is-visible');
    }

    var addBtn = qs('[data-sticky-add]', sticky);
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = qs('[data-variant-id], input[name="id"]', mainForm);
        if (!variantId || !variantId.value) {
          showCartError({ message: strings.unavailable || 'Unavailable' });
          return;
        }
        var original = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = strings.adding || 'Adding…';
        var formData = new FormData(mainForm);
        formData.set('id', variantId.value);
        if (!formData.get('quantity')) {
          formData.set('quantity', '1');
        }
        Cart.add(formData)
          .then(function (data) {
            updateCartCount(data.item_count);
            return refreshCartDrawer();
          })
          .then(function () {
            openCartDrawer();
          })
          .catch(function (err) {
            showCartError(err);
          })
          .finally(function () {
            addBtn.disabled = false;
            addBtn.textContent = original;
          });
      });
    }
  }

  function showCartError(err) {
    var message = (err && (err.description || err.message)) || strings.cartError || 'Error';
    var errorEl = qs('[data-form-error]:not([hidden])') || qs('[data-form-error]');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      setTimeout(function () { errorEl.hidden = true; }, 4000);
    } else {
      alert(message);
    }
  }

  /* ---------- Customer Privacy & Cookie Consent ---------- */

  function ensureCustomerPrivacy(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
      if (typeof callback === 'function') { callback(); }
      return;
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([
        {
          name: 'consent-tracking-api',
          version: '0.1'
        }
      ], function (err) {
        if (err) {
          console.warn('Customer Privacy API load error:', err);
        }
        if (typeof callback === 'function') { callback(); }
      });
    } else if (typeof callback === 'function') {
      callback();
    }
  }

  function openCookiePreferences() {
    ensureCustomerPrivacy(function () {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') {
        window.Shopify.customerPrivacy.showPreferences();
      } else {
        console.warn('Shopify Customer Privacy preferences modal is not available yet.');
      }
    });
  }

  window.theme = window.theme || {};
  window.theme.customerPrivacy = {
    ensure: ensureCustomerPrivacy,
    showPreferences: openCookiePreferences,
    isAnalyticsAllowed: function () {
      return !(window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') ||
        window.Shopify.customerPrivacy.analyticsProcessingAllowed();
    },
    isMarketingAllowed: function () {
      return !(window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.marketingAllowed === 'function') ||
        window.Shopify.customerPrivacy.marketingAllowed();
    }
  };

  /* ---------- Global click delegation ---------- */

  document.addEventListener('click', function (e) {
    var target = e.target;

    var cookiePrefBtn = target.closest('[data-open-cookie-preferences], [data-cookie-preferences]');
    if (cookiePrefBtn) {
      e.preventDefault();
      openCookiePreferences();
      return;
    }

    var quickViewBtn = target.closest('[data-quick-view]');
    if (quickViewBtn) {
      e.preventDefault();
      fetchQuickView(quickViewBtn.getAttribute('data-quick-view-url'));
      return;
    }

    var modalClose = target.closest('[data-modal-close]');
    if (modalClose) {
      e.preventDefault();
      closeQuickView();
      return;
    }

    var cartOpen = target.closest('[data-cart-open]');
    if (cartOpen) {
      e.preventDefault();
      openCartDrawer();
      return;
    }

    if (target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }

    if (target.closest('[data-menu-open]')) {
      e.preventDefault();
      openMenuDrawer();
      return;
    }

    if (target.closest('[data-menu-close]')) {
      e.preventDefault();
      closeMenuDrawer();
      return;
    }

    var searchToggle = target.closest('[data-search-toggle]');
    if (searchToggle) {
      e.preventDefault();
      var bar = qs('#SearchBar');
      var isOpen = bar.classList.toggle('is-open');
      bar.setAttribute('aria-hidden', String(!isOpen));
      searchToggle.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) { qs('[data-search-input]', bar).focus(); }
      return;
    }

    if (target.closest('[data-search-close]')) {
      e.preventDefault();
      var bar2 = qs('#SearchBar');
      bar2.classList.remove('is-open');
      bar2.setAttribute('aria-hidden', 'true');
      return;
    }

    var qtyBtn = target.closest('[data-qty-plus], [data-qty-minus]');
    if (qtyBtn) {
      e.preventDefault();
      stepQty(qtyBtn);
      return;
    }

    var lineChange = target.closest('[data-line-change]');
    if (lineChange) {
      e.preventDefault();
      var wrap = lineChange.closest('.qty');
      var lineInput = qs('[data-line-qty]', wrap);
      if (!lineInput) { return; }
      var line = parseInt(lineChange.getAttribute('data-line-change'), 10);
      var delta = parseInt(lineChange.getAttribute('data-delta'), 10);
      var newQty = (parseInt(lineInput.value, 10) || 0) + delta;
      if (newQty < 0) { newQty = 0; }
      lineInput.value = newQty;
      Cart.change(line, newQty)
        .then(function (cart) { return afterCartMutation(cart); })
        .catch(function (err) {
          refreshCartDrawer().catch(function () { }).then(function () { showCartError(err); });
        });
      return;
    }

    var lineRemove = target.closest('[data-line-remove]');
    if (lineRemove) {
      e.preventDefault();
      Cart.change(parseInt(lineRemove.getAttribute('data-line-remove'), 10), 0)
        .then(function (cart) { return afterCartMutation(cart); })
        .catch(function (err) {
          refreshCartDrawer().catch(function () { }).then(function () { showCartError(err); });
        });
      return;
    }

    var buyNowBtn = target.closest('[data-buy-now]');
    if (buyNowBtn) {
      if (buyNowBtn.closest('[class*="ai-product-form"]')) { return; }
      e.preventDefault();
      var buyForm = buyNowBtn.closest('form') || qs('[data-product-form-main]');
      if (!buyForm) { return; }
      var variantInput = qs('[data-variant-id], input[name="id"]', buyForm);
      if (!variantInput || !variantInput.value) {
        showCartError({ message: strings.unavailable || 'Unavailable' });
        return;
      }
      var originalBuyText = buyNowBtn.textContent;
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = strings.adding || 'Adding…';
      Cart.add(new FormData(buyForm))
        .then(function () {
          window.location.href = getCheckoutUrl();
        })
        .catch(function (err) {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = originalBuyText;
          showCartError(err);
        });
      return;
    }

    var cartAddBtn = target.closest('[data-cart-add]');
    if (cartAddBtn) {
      e.preventDefault();
      var variantToAdd = cartAddBtn.getAttribute('data-cart-add');
      if (!variantToAdd) {
        showCartError({ message: strings.unavailable || 'Unavailable' });
        return;
      }
      var hasIcon = Boolean(cartAddBtn.querySelector('svg'));
      var originalText = cartAddBtn.textContent;
      cartAddBtn.disabled = true;
      if (hasIcon) {
        cartAddBtn.classList.add('is-loading');
      } else {
        cartAddBtn.textContent = strings.adding || 'Adding…';
      }

      // Instant visual response: open cart drawer immediately while request is in flight
      openCartDrawer();

      var fd = new FormData();
      fd.append('id', variantToAdd);
      fd.append('quantity', '1');
      Cart.add(fd)
        .then(function (data) {
          updateCartCount(data.item_count);
          return refreshCartDrawer();
        })
        .catch(function (err) {
          showCartError(err);
        })
        .finally(function () {
          cartAddBtn.disabled = false;
          if (hasIcon) {
            cartAddBtn.classList.remove('is-loading');
          } else {
            cartAddBtn.textContent = originalText;
          }
        });
      return;
    }

    // Instant product card navigation when tapping anywhere on the card outside buttons
    var card = target.closest('.product-card');
    if (card && !target.closest('button, .icon-btn, a, [data-quick-view], [data-cart-add]')) {
      var prodUrl = card.getAttribute('data-product-url');
      if (prodUrl) {
        window.location.href = prodUrl;
        return;
      }
    }

    var thumb = target.closest('[data-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-gallery]');
      var mainImg = gallery && qs('[data-main-image]', gallery);
      if (mainImg) {
        mainImg.srcset = '';
        mainImg.src = thumb.getAttribute('data-full-src');
        qsa('[data-thumb]', gallery).forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      }
      return;
    }
  });

  /* ---------- Form submissions (Cart & Checkout) ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;

    // Preserve native Shopify checkout submission to /cart with name="checkout"
    var submitter = e.submitter;
    if (!submitter && document.activeElement && document.activeElement.form === form) {
      submitter = document.activeElement;
    }
    var isCheckoutSubmit = (submitter && submitter.name === 'checkout') ||
      (form.hasAttribute('data-checkout-form') && (!submitter || submitter.name !== 'update')) ||
      form.classList.contains('cart-drawer-checkout-form');

    if (isCheckoutSubmit) {
      if (form.getAttribute('data-submitting') === 'true') {
        e.preventDefault();
        return;
      }
      form.setAttribute('data-submitting', 'true');
      var checkoutBtn = (submitter && submitter.name === 'checkout') ? submitter : qs('button[name="checkout"]', form);
      if (checkoutBtn) {
        checkoutBtn.classList.add('is-submitting');
        // Do NOT disable checkoutBtn via DOM disabled property, as that can cause
        // mobile Safari and Chrome to omit the name="checkout" field from form submission.
        // Double-clicks are already prevented by CSS pointer-events: none on .is-submitting.
      }
      // Safety auto-recovery timer: if page did not navigate within 6s, restore interaction
      setTimeout(function () {
        form.removeAttribute('data-submitting');
        if (checkoutBtn) {
          checkoutBtn.classList.remove('is-submitting');
        }
      }, 6000);
      return; // Allow native form POST to /cart with name="checkout" to proceed uninterrupted
    }

    if (!form.matches('form[action*="/cart/add"]')) { return; }
    if (!theme.cartDrawer) { return; }
    if (form.hasAttribute('data-no-ajax')) { return; }

    // Never hijack checkout submissions (Buy Now / dynamic payment button).
    if (submitter && submitter.name === 'checkout') { return; }

    e.preventDefault();
    var variantInput = qs('[data-variant-id], input[name="id"]', form);
    if (!variantInput || !variantInput.value) {
      showCartError({ message: strings.unavailable || 'Unavailable' });
      return;
    }

    var btn = qs('[data-atc]', form);
    var original = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = strings.adding || 'Adding…';
    }

    // Instant visual response: open drawer and dismiss quick view immediately
    closeQuickView();
    openCartDrawer();

    Cart.add(new FormData(form))
      .then(function (data) {
        updateCartCount(data.item_count);
        return refreshCartDrawer();
      })
      .catch(function (err) {
        showCartError(err);
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = original;
        }
      });
  });

  /* ---------- Change events ---------- */

  document.addEventListener('change', function (e) {
    var input = e.target;

    if (input.matches('[data-qty-input]')) {
      var typedValue = parseInt(input.value, 10) || 1;
      var typedMin = parseInt(input.getAttribute('min'), 10);
      var typedMax = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(typedMin) && typedValue < typedMin) { input.value = typedMin; }
      else if (!isNaN(typedMax) && typedValue > typedMax) { input.value = typedMax; }
    }

    if (input.matches('[data-line-qty]')) {
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      Cart.change(parseInt(input.getAttribute('data-line-qty'), 10), qty)
        .then(function (cart) { return afterCartMutation(cart); })
        .catch(function (err) {
          refreshCartDrawer().catch(function () { }).then(function () { showCartError(err); });
        });
      return;
    }

    if (input.matches('[data-sort-select]')) {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', input.value);
      params.delete('page');
      window.location.search = params.toString();
      return;
    }

    if (input.matches('[data-sort-hidden]')) {
      input.value = input.value;
    }

    if (input.closest('#FacetFilterForm')) {
      var hiddenSort = qs('[data-sort-hidden]');
      var sortSelect = qs('[data-sort-select]');
      if (hiddenSort && sortSelect) { hiddenSort.value = sortSelect.value; }
      var facetForm = qs('#FacetFilterForm');
      if (facetForm) {
        facetForm.submit();
      }
    }
  });

  /* ---------- Keyboard ---------- */

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeQuickView();
      closeCartDrawer();
      closeMenuDrawer();
      var bar = qs('#SearchBar.is-open');
      if (bar) {
        bar.classList.remove('is-open');
        bar.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    if (e.key === 'Tab' && quickViewRoot && quickViewRoot.classList.contains('is-open')) {
      var panel = qs('[data-quick-view-panel]');
      var focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', panel)
        .filter(function (el) { return el.offsetParent !== null; });
      if (focusable.length === 0) { return; }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  /* ---------- Page Show (BFCache Restoration) ---------- */

  window.addEventListener('pageshow', function () {
    qsa('form[data-submitting="true"]').forEach(function (form) {
      form.removeAttribute('data-submitting');
      var btn = qs('button[name="checkout"]', form);
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('is-submitting');
      }
    });
    qsa('[data-buy-now]').forEach(function (btn) {
      btn.disabled = false;
    });
  });

  /* ---------- Init ---------- */

  function init() {
    initHeaderHeight();
    initVariantPickers(document);
    initStickyAtc();
    ensureCustomerPrivacy();

    var facets = qs('[data-facets]');
    if (facets && window.innerWidth >= 768) {
      facets.open = true;
    }

    optimizeCurrencyDropdownDOM();
  }

  /* ---------- Optimize Currency Dropdown DOM on Initial Load ---------- */
  function optimizeCurrencyDropdownDOM() {
    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutations, obs) {
      var select = qs('select[class*="currency"], select[id*="currency"], [class*="hoppy"] select');
      if (select && select.options && select.options.length > 50) {
        var allOptions = Array.from(select.options);
        var selectedVal = select.value;
        var topCurrencies = ['EGP', 'USD', 'EUR', 'SAR', 'AED', 'KWD', 'GBP', 'QAR'];

        var restored = false;
        function restoreAllOptions() {
          if (restored) return;
          restored = true;
          select.innerHTML = '';
          allOptions.forEach(function (opt) {
            select.appendChild(opt);
          });
          select.value = selectedVal;
          select.removeEventListener('focus', restoreAllOptions);
          select.removeEventListener('pointerdown', restoreAllOptions);
          select.removeEventListener('touchstart', restoreAllOptions);
        }

        // Keep active and top currencies in DOM during initial render
        select.innerHTML = '';
        allOptions.forEach(function (opt) {
          if (opt.value === selectedVal || topCurrencies.indexOf(opt.value) !== -1) {
            select.appendChild(opt.cloneNode(true));
          }
        });
        select.value = selectedVal;

        select.addEventListener('focus', restoreAllOptions, { passive: true });
        select.addEventListener('pointerdown', restoreAllOptions, { passive: true });
        select.addEventListener('touchstart', restoreAllOptions, { passive: true });

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(restoreAllOptions, { timeout: 3500 });
        } else {
          setTimeout(restoreAllOptions, 2500);
        }

        obs.disconnect();
      }
    });

    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      observer.disconnect();
    }, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
